import React, {Component} from 'react';

import Registry from '../../../registry/index';

class MoodPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        const { 
            user,
            close,
            fullscreen,
        } = this.props;

        let lang = Registry.get('locale');

        if(!fullscreen) return false;

        return (
            <div className={`video-popup mood fade-effect`} ref={(videoPopup) => { this.videoPopup = videoPopup }}>
                <div className="header">
                    <div className="title">{lang.mood}</div>
                    <div className="icon-close" onClick={() => close()}/>
                </div>
                <div className="body">
                    {user.mood}
                </div>
            </div>
        );
    }
}

export default MoodPanel;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/VideoWindow/MoodPanel.js